import LivingCanvas from "../../components/marketing/LivingCanvas";
import MobileMenu from "../../components/marketing/MobileMenu";
import Navigation from "../../components/marketing/Navigation";
import FloatingBadge from "../../components/marketing/FloatingBadge";
import { siteSections } from "../../content/siteSections";
import useStickyNav from "../../hooks/useStickyNav";

/**
 * Shared marketing layout for homepage and blog routes.
 * Translation: Shared marketing layout for homepage and blog routes.
 *
 * @param {Object} props - Layout props.
 * @returns {JSX.Element} Marketing layout.
 */
const MarketingLayout = ({ children, footer, heroRef, showFloatingBadge = true }) => {
  const isSticky = useStickyNav(heroRef);

  return (
    <>
      <LivingCanvas />
      <div className="app-shell">
        <a href="#main-content" className="skip-nav">Skip to main content</a>
        <Navigation isSticky={isSticky} />
        <MobileMenu />
        {showFloatingBadge ? (
          <FloatingBadge label={siteSections.availabilityBadge} />
        ) : null}
        <main id="main-content" className="page-shell">{children}</main>
        {footer}
      </div>
    </>
  );
};

export default MarketingLayout;
